import { isNodeWithChildren } from '../../utils/isNodeWithChildren';
import { loadMissingFontsFromTextNodes } from './loadMissingFonts';

export const loadMissingFontsFromNode = async (node: BaseNode) => {
  if (!isNodeWithChildren(node)) return;

  const textNodes = node.findAll(
    (subnode) => subnode.type === 'TEXT'
  ) as TextNode[];

  await loadMissingFontsFromTextNodes(textNodes);
};
